import { createFileRoute, redirect } from '@tanstack/react-router';

import { getCurrentSession } from '../app/auth-state';

// The root has no content of its own: it is just the entry point of
// admin.jqrace4.com. It mirrors the `beforeLoad` of `/login` (which sends an
// already-authenticated user to the dashboard) so neither route can be
// reached with the wrong session state.
//
// The authenticated target is always `/dashboard`: that is where the role
// dispatch lives (`resolveDashboardRoleRedirect`), so supervisor and
// super_admin land on their own home without duplicating that role table here.
export const Route = createFileRoute('/')({
  beforeLoad: () => {
    throw redirect({ to: getCurrentSession() ? '/dashboard' : '/login' });
  },
});
